import React from 'react';
import ComponentContext from './component-context';
import ErrorBoundary from './error-boundary';
import { ItemKeyHelper } from 'src/components/common/helper';

export interface ComponentLayoutType<T> {
  moduleName: string;
  status?: boolean;
  children?: React.ReactNode;
  data?: T;
  handleEvent?(): void;
  defaultSetting?: T;
}

const ComponentLayout = (props: ComponentLayoutType<any>) => {
  const componentContextValue = React.useMemo(() => {
    const componentKey = new ItemKeyHelper(props?.moduleName?.toLowerCase()?.replaceAll(' ', '-'));

    const { data, ...rest } = props;
    return {
      componentProps: {
        data: data || null,
        key: componentKey,
        ...rest,
      },
    };
  }, [props]);

  return (
    <ErrorBoundary>
      <ComponentContext.Provider value={componentContextValue}>{props?.children}</ComponentContext.Provider>
    </ErrorBoundary>
  );
};

export default ComponentLayout;
